import Vue from "vue";
import Vuex from "vuex";

import employeeForm from "@/store/modules/employee-form";
import referenceDismissalReasons from "@/store/modules/reference-dismissal-reasons";
import referenceWorkerStatuses from "@/store/modules/reference-worker-statuses";
import referenceCandidateStatuses from "@/store/modules/reference-candidate-statuses";
import referenceWorkerCharacteristics from "@/store/modules/reference-worker-characteristics";
import referenceEmploymentStatuses from "@/store/modules/reference-employment-statuses";
import referenceViolationTypes from "@/store/modules/reference-violation-types";
import referenceReasonsForBonuses from "@/store/modules/reference-reasons-for-bonuses";
import referenceReasonsForFines from "@/store/modules/reference-reasons-for-fines";
import referenceHolidaySurcharges from "@/store/modules/reference-holiday-surchages";
import referenceMoneySource from "@/store/modules/reference-money-source";
import referenceLoadTypes from "@/store/modules/reference-load-types";
import referenceMoneyTransaction from "@/store/modules/reference-money-transaction";
import finesAndBonuses from "@/store/modules/fines-and-bonuses";
import app from "./modules/app";

import competencies from "./modules/competencies";

import calculations from "./modules/calculations";
import calculationSheets from "./modules/calculation-sheets";

import employees from "./modules/employees";
import financialTransactions from "./modules/financial-transactions";
import positions from "./modules/positions";
import actors from "./modules/actors";
import profile from "./modules/profile";

import functions from "./modules/functions";

import references from "./modules/references";
import referenceClients from "./modules/reference-clients";
import uniform from "./modules/uniform";
import uniformItems from "./modules/uniform-items";
import referenceVacationTypes from "./modules/reference-vacation-types";
import referenceIiko from "./modules/reference-iiko";
import referencePrivateTransactionsReasons from "./modules/reference-private-transactions-reasons";
import referenceWorkSchedules from "./modules/reference-work-schedules";
import referenceReasonsForRejectCandidate from "./modules/reference-reasons-for-reject-candidate";

import debtReport from "./modules/debt-report";
import documentsReport from "./modules/documents-report";
import medicalAnalysesReport from "./modules/medical-analyses-report";
import couriersReport from "./modules/couriers-report";
import violationsReport from "./modules/violations-report";
import finesAndBonusesReport from "./modules/fines-and-bonuses-report";

import vacationsChart from "./modules/vacations-chart";
import timesheets from "./modules/timesheets";

import personalEmployee from "./modules/personal-employee";
import documents from "./modules/documents";
import documentForm from "./modules/document-form";
import filters from "./modules/filters";
import chat from "./modules/chat";
import uikit from "./modules/uikit";
import test from "./modules/test";
import commonTest from "./modules/commonTest";
import medicalAnalyses from "./modules/medical-analyses";
import medicalAnalysesForm from "./modules/medical-analyses-form";
import violations from "./modules/violations";
import educationalMaterials from "./modules/educational-materials";
import autoCreationCalcSheets from "./modules/auto-creation-calc-sheets";


import candidates from "./modules/staff/candidates";
import candidatesReport from "./modules/staff/candidates-report";

import tablesSettings from "./modules/tables-settings";
import olap from "./modules/olap";

Vue.use(Vuex);

const api_url = "/index.php";

export default new Vuex.Store({
    modules: {
        app,
        calculations,
        calculationSheets,
        employees,
        employeeForm,
        test,
        commonTest,
        positions,
        chat,

        actors,
        profile,

        functions,

        uniform,
        uniformItems,

        autoCreationCalcSheets,
        
        references,
        referenceClients,
        referenceVacationTypes,
        referenceIiko,
        referencePrivateTransactionsReasons,
        referenceWorkSchedules,
        referenceDismissalReasons,
        referenceReasonsForRejectCandidate,
        referenceWorkerStatuses,
        referenceCandidateStatuses,
        referenceWorkerCharacteristics,
        referenceEmploymentStatuses,
        referenceViolationTypes,
        referenceReasonsForBonuses,
        referenceReasonsForFines,
        referenceHolidaySurcharges,
        referenceMoneySource,
        referenceLoadTypes,
        referenceMoneyTransaction,

        debtReport,
        documentsReport,
        medicalAnalysesReport,
        couriersReport,
        violationsReport,
        finesAndBonusesReport,
        olap,
        vacationsChart,
        timesheets,

        personalEmployee,
        documents,
        documentForm,
        medicalAnalyses,
        medicalAnalysesForm,
        filters,
        uikit,
        violations,
        finesAndBonuses,
        financialTransactions,
        tablesSettings,
        educationalMaterials,

        candidates,
        candidatesReport,

        competencies
    },

    state: {
        user: {},

        users: [
            {
                id: 1,
                name: "Василий Иванов",
                avatar: "https://i.pravatar.cc/34?img=1",
            },
            {
                id: 2,
                name: "Александр Константинопольский",
                avatar: "https://i.pravatar.cc/34?img=2",
            },
            {
                id: 3,
                name: "Николаев Николай Николаевич",
                avatar: "https://i.pravatar.cc/34?img=3",
            },
            {
                id: 4,
                name: "Сергеев Сергей Сергеевич",
                avatar: "https://i.pravatar.cc/34?img=4",
            },
            {
                id: 5,
                name: "Иванов Иван Иванович",
                avatar: "https://i.pravatar.cc/34?img=5",
            },
            {
                id: 6,
                name: "Петров Петр Петрович",
                avatar: "https://i.pravatar.cc/34?img=6",
            },
            {
                id: 7,
                name: "Николаев Николай Николаевич",
                avatar: "https://i.pravatar.cc/34?img=7",
            },
            {
                id: 8,
                name: "Сергеев Сергей Сергеевич",
                avatar: "https://i.pravatar.cc/34?img=8",
            },
        ],

        authToken: document.body.dataset.authtoken,

        userId: document.body.dataset.userid,

        isAccessIikoCustomersControl: document.body.dataset.isaccessiikocustomerscontrol,

        isLogged: false,

        userPermissions: [],
    },

    getters: {
        user(state) {
            return state.user;
        },

        users(state) {
            return state.users;
        },

        isLogged(state) {
            return state.authToken && state.userId;
        },

        getAuthToken(state) {
            return state.authToken;
        },

        getUserId(state) {
            return state.userId;
        },

        isAccessIikoCustomersControl(state) {
            return state.isAccessIikoCustomersControl;
        },

        getUserPermissions(state) {
            return state.userPermissions;
        },
    },

    mutations: {
        setUserPermissions(state, userPermissions) {
            state.userPermissions = userPermissions;
        },
        setUserInfo(state, data) {
            state.user = { ...data };
        },
    },

    actions: {
        async getUserPermissions({ commit, getters }) {
            const userId = getters.getUserId;
            const authToken = getters.getAuthToken;

            const res = await fetch(
                `${api_url}/?r=api/permissions/user-permissions&user_id=${userId}&auth_key=${authToken}`,
            );

            const json = await res.json();

            commit("setUserPermissions", json.response);

            return json;
        },
        async getUserInfo({ commit, rootState }) {
            const token = rootState.authToken;
            const { userId } = rootState;

            const res = await fetch(`${api_url}/?r=api/worker-profile/info&user_id=${userId}&auth_key=${token}`);

            const json = await res.json();

            commit("setUserInfo", json);

            return json;
        },
    },
});
